<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
